import React from 'react'
import { Space, Statistic } from 'antd'
import { useSelector } from 'react-redux'

const FeedbackFromStudentsStatistics = () => {
    const assignmentStudentsFeedback = useSelector(state => state.assignments.assignmentStudentsFeedback)

    const uniqueLikesCount = assignmentStudentsFeedback.filter(
        assignmentStudentFeedback => assignmentStudentFeedback.liked,
    ).length
    const likesCount = assignmentStudentsFeedback.reduce((sum, feedback) => {
        if (feedback.liked) sum++
        feedback.older_feedbacks.map(olderFeedback => {
            if (olderFeedback.liked) sum++
        })
        return sum
    }, 0)
    const totalFeedbacksCount = assignmentStudentsFeedback.reduce(
        (sum, feedback) => sum + feedback.older_feedbacks.length + 1,
        0,
    )

    return (
        <Space size={48}>
            <Statistic
                title='Unique Likes'
                value={uniqueLikesCount}
                suffix={`/ ${assignmentStudentsFeedback.length}`}
                className='mb-16'
            />
            <Statistic title='Likes' value={likesCount} suffix={`/ ${totalFeedbacksCount}`} className='mb-16' />
        </Space>
    )
}

export default FeedbackFromStudentsStatistics
